/**
 * Copy text string to clipboard from the target element
 */

export default (() => {
  const copyToClipboard = (text) => {
    return navigator.clipboard.writeText(text)
  }

  const handleButtonClick = (event) => {
    const button = event.currentTarget
    const originalInnerHTML = button.innerHTML

    const hasDoneLabelAttr = button.hasAttribute('data-done-label')
    const doneLabel = hasDoneLabelAttr
      ? button.getAttribute('data-done-label')
      : 'Copied'

    const selector = button.getAttribute('data-copy-text-from')
    const targetElement = document.querySelector(selector)

    if (!targetElement) return

    const textToCopy = targetElement.value ?? targetElement.textContent ?? ''

    copyToClipboard(textToCopy)
      .then(() => {
        button.innerHTML = doneLabel
          ? `<i class="ci-check me-1"></i> ${doneLabel}`
          : `<i class="ci-check"></i>`

        setTimeout(() => {
          button.innerHTML = originalInnerHTML
        }, 2000)
      })
      .catch((err) => {
        console.error('Error in copying text: ', err)
      })
  }

  const buttons = document.querySelectorAll('button[data-copy-text-from]')
  buttons.forEach((button) => {
    button.addEventListener('click', handleButtonClick)
  })
})()
